import { render, staticRenderFns } from "./ObjectField.vue?vue&type=template&id=5e34affd"
import script from "./ObjectField.vue?vue&type=script&lang=js"
export * from "./ObjectField.vue?vue&type=script&lang=js"
import style0 from "./ObjectField.vue?vue&type=style&index=0&id=5e34affd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports